const tourRequestListeners = new Set();

export const requestProductTour = ({ tourKey, launchMode, returnFocusTo = null }) => {
  const request = {
    tourKey: String(tourKey || "").trim(),
    launchMode: String(launchMode || "manual_section").trim(),
    // The element focus goes back to when the tour ends. The launcher passes it
    // explicitly because the menu item that was focused on click is destroyed
    // before the tour starts.
    returnFocusTo,
  };
  if (!request.tourKey) return;
  tourRequestListeners.forEach((listener) => listener(request));
};

export const subscribeToProductTourRequests = (listener) => {
  if (typeof listener !== "function") return () => {};
  tourRequestListeners.add(listener);
  return () => tourRequestListeners.delete(listener);
};
